import React from "react";
import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import "./TemperatureSensor.scss";
import viewicon from "../../assets/images/view-icon.svg";
import threedotvertical from "../../assets/images/three-dots-vertical.svg";
import play from "../../assets/images/play.svg";
import stop from "../../assets/images/stop-circle.svg";
import areaChartIcon from "../../assets/images/area_chart_icon.svg";
import { ReactSVG } from "react-svg";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
// import { selectCurrentUserId } from "../../redux/auth/authSlice";
import useSensors from "../../Hooks/useSensor";
import { toggleClass } from "../../utils/commonUtils";
// import { setSelectedSensor } from "../../redux/sensor/sensorSlice";
import Loading from "../../components/LoadingPage/Loading";
import { toast } from "react-toastify";
import GraphModel from "../../components/graphModel/graphModel";
import { setCurrentSensor } from "../../redux/sensor/sensorSlice";
import { selectCurrentUserId } from "../../redux/auth/authSlice";
import BatteryDisplay from "../../components/BatteryDisplay/BatteryDisplay";

const TemperatureSensor = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentUserId =
    localStorage.getItem("profileClientId")?.toUpperCase() ?? "";
  const {
    getSensorListAPI,
    getSensorLoading,
    startSensorAPI,
    startSensorLoading,
    stopSensorAPI,
    stopSensorLoading,
  } = useSensors();
  const [sensorsList, setSensorsList] = useState<any[]>([]);
  const [showGraphModel, setShowGraphModel] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState<any>();
  const [sortColumn, setSortColumn] = useState("ClientCode");
  const [sortDirection, setSortDirection] = useState("asc"); // 'asc' or 'desc'
  const defaultFilter = {
    sortColumn: sortColumn,
    sortDirection: sortDirection,
  };
  const [searchFieldVal, setSearchFieldVal] = useState(defaultFilter);

  const handleSort = (column: string) => {
    let direction = "asc";
    if (sortColumn === column) {
      direction = sortDirection === "asc" ? "desc" : "asc";
    }
    setSortColumn(column);
    setSortDirection(direction);
    setSearchFieldVal({ sortColumn: column, sortDirection: direction });
  };

  const handleSensorGraph = (id: string) => {
    setSelectedSensor(sensorsList?.find((x: any) => id === x.id));
    toggleClass();
    setShowGraphModel(!showGraphModel);
  };
  /*Graph Model Toggle model */
  const toggleGraphModal = () => {
    toggleClass();
    setShowGraphModel(!showGraphModel);
  };
  const getList = () => {
    getSensorListAPI({ tenantId: currentUserId, ...searchFieldVal }).then(
      (res: any[]) => {
        if (res) {
          setSensorsList([...res]);
        } else {
          setSensorsList([]);
        }
      }
    );
  };
  /* Start the Sensor */
  const handleStartSensor = (sensorId: string) => {
    startSensorAPI({
      id: sensorId,
    })
      .then((res: any) => {
        if (res) {
          toast.success(res?.message);
          getList();
        }
        return res;
      })
      .catch((err) => {
        // toast.error(err?.message);
        return err;
      });
  };

  /* Stop the Sensor */
  const handleStopSensor = (sensorId: string) => {
    stopSensorAPI({
      id: sensorId,
    })
      .then((res: any) => {
        if (res) {
          toast.success(res?.message);
          getList();
        }
        return res;
      })
      .catch((err: any) => {
        // toast.error(err?.message);
        return err;
      });
  };
  const navigateToView = (sensor: any) => {
    dispatch(setCurrentSensor(sensor));
    setSelectedSensor(sensor);
    navigate("/manage-sensor");
  };
  useEffect(() => {
    getList();
  }, [searchFieldVal]);
  return (
    <div className="sensor-listing-wrapper">
      {getSensorLoading || startSensorLoading || stopSensorLoading ? (
        <Loading />
      ) : null}
      <div className="sensor-header">
        <h2>Temperature Sensors</h2>
      </div>
      <div className="listing-table-wrapper">
        <Table responsive="md" hover={true}>
          <thead>
            <tr>
              <th style={{ cursor: "pointer" }} onClick={() => handleSort("SerialNumber")}>
                Serial Number {sortColumn === "SerialNumber" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th style={{ cursor: "pointer" }} onClick={() => handleSort("SensorName")}>
                Sensor Name {sortColumn === "SensorName" && (sortDirection === "asc" ? "↑" : "↓")}
              </th>
              <th className="text-center">Low/High Temp.</th>
              <th className="text-center">Interval Duration</th>
              <th className="text-center">Battery Level</th>
              <th className="text-center">Status</th>
              <th className="text-center">Active</th>
              {/* <th className="text-center">IsRunning</th> */}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {sensorsList?.map((sensor: any) => (
              <tr key={sensor.id} onDoubleClick={() => navigateToView(sensor)}>
                <td title={sensor.serialNumber}>{sensor.serialNumber}</td>
                <td title={sensor.sensorName}>{sensor.sensorName}</td>
                <td title={sensor?.temperatureDisplay} className="text-center">{sensor?.temperatureDisplay}</td>
                <td title={sensor?.intervalDisplay} className="text-center">{sensor?.intervalDisplay}</td>
                <td title={sensor?.batteryLevel} className="text-center"> {sensor?.batteryLevel ? <BatteryDisplay level={sensor?.batteryLevel ?? 0} /> : '-'}</td>
                <td title={sensor?.sensorTaskStatus == null ? "No" : "Yes"}
                  className="text-center"
                >
                  <span
                    className={`tbl-badge ${sensor?.sensorTaskStatusColor !== null
                      ? `active text-${sensor?.sensorTaskStatusColor?.toLowerCase()}`
                      : ''
                      }`}
                  >
                    <div className="d-flex align-items-center">
                      {sensor?.sensorTaskStatus !== null ? sensor?.sensorTaskStatus : '-'}
                    </div>
                  </span>
                </td>
                <td className="text-center">
                  <span className={`status-circle ${sensor.isActive ? "active" : "inactive"}`}>
                    {sensor?.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                {/* <td className="text-center">
                  <span className={`status-circle ${sensor?.taskId == null ? "inactive" : "active"}`}>
                    {sensor?.taskId == null ? "No" : "Yes"}
                  </span>
                </td> */}
                <td>
                  <Dropdown>
                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                      <ReactSVG className="svg-box" wrapper="span" src={threedotvertical} />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={() => navigateToView(sensor)}>
                        <ReactSVG className="svg-box" wrapper="span" src={viewicon} /> View
                      </Dropdown.Item>
                      {sensor.taskId == null ? (
                        <Dropdown.Item onClick={() => handleStartSensor(sensor.id)}>
                          <ReactSVG className="svg-box" wrapper="span" src={play} /> Start Sensor
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item onClick={() => handleStopSensor(sensor.id)}>
                          <ReactSVG className="svg-box" wrapper="span" src={stop} /> Stop Sensor
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item onClick={() => handleSensorGraph(sensor.id)}>
                        <ReactSVG className="svg-box" wrapper="span" src={areaChartIcon} /> Temp Graph
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* <DeleteConfModel
        showModal={showModal}
        toggleModal={toggleModal}
        deleteAction={deleteStock}
        recordName={currentStock?.stockName || ""}
        modelName={`stock`}
      /> */}
      {showGraphModel && (
        <GraphModel
          showModal={showGraphModel}
          toggleModal={toggleGraphModal}
          modelName={`Temperature Log`}
          sensorData={selectedSensor}
        />
      )}
    </div>
  );
};
export default TemperatureSensor;
